import { render, staticRenderFns } from "./triageList.vue?vue&type=template&id=5b3698e2&scoped=true&"
import script from "./triageList.vue?vue&type=script&lang=js&"
export * from "./triageList.vue?vue&type=script&lang=js&"
import style0 from "./triageList.vue?vue&type=style&index=0&id=5b3698e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3698e2",
  null
  
)

export default component.exports